import { FaTimes } from "react-icons/fa";
import styled from "styled-components";
import colors from "../../../../../styles/colors";

export const LabelsContainer = styled.div`
  min-height: 5rem;
  background: ${colors.lightgrey};
  display: inline-block;
  display: flex;
  border-radius: 0.5rem;
  flex-wrap: wrap;
  padding: 0.5rem;
  position: relative;
`;

export const HintContainer = styled.div`
  height: 5rem;
  background: ${colors.lightyellow};
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
`;

export const Label = styled.div<{ isEditing: boolean }>`
  align-items: center;
  border-radius: 0.5rem;
  border: 1px solid ${colors.darkgrey};
  box-shadow: 0.1rem 0.1rem 0.25rem rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  display: list-item;
  justify-content: center;
  margin: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: ${({ isEditing }) => (isEditing ? "2rem" : "0.5rem")};
  list-style: none;
  position: relative;
`;

export const RemoveIcon = styled(FaTimes)`
  align-self: flex-start;
  cursor: pointer;
  font-size: 1.1rem;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  &:hover {
    transition: color 0.25s;
    color: ${colors.red};
  }
`;
